import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

interface Props {
  size?: number;
  style?: React.CSSProperties;
}

const GradientCircularProgress: React.FC<Props> = props => {
  const { size, style } = props;
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...style
      }}
    >
      <svg
        width={0}
        height={0}
        style={{
          position: "absolute",
          width: 0,
          height: 0,
          opacity: 0,
          pointerEvents: "none"
        }}
      >
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#68368b" />
            <stop offset="100%" stopColor="#FFB132" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress
        sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
        size={size ? size : 40}
        thickness={5}
      />
    </div>
  );
};

export default GradientCircularProgress;
